'use client';

import { useState, useTransition } from 'react';

import { Button } from '@/shared/ui/button';
import { Dialog, DialogFooter } from '@/shared/ui/dialog';

import { resetCourseProgressAction } from '../action/reset-course-progress';

interface ResetProgressButtonProps {
	courseId: string;
	courseName?: string;
}

export const ResetProgressButton = ({
	courseId,
	courseName,
}: ResetProgressButtonProps) => {
	const [isOpen, setIsOpen] = useState(false);
	const [isPending, startTransition] = useTransition();

	const handleReset = () => {
		startTransition(async () => {
			await resetCourseProgressAction(courseId);
			setIsOpen(false);
		});
	};

	return (
		<>
			<Button
				variant="outline"
				size="sm"
				onClick={() => setIsOpen(true)}
				className="border-gray-4 text-red hover:border-red hover:bg-red-light"
			>
				Сбросить прогресс
			</Button>

			<Dialog
				open={isOpen}
				onClose={setIsOpen}
				title="Сброс прогресса курса"
				footer={
					<DialogFooter className="justify-end gap-3">
						<Button
							variant="outline"
							onClick={() => setIsOpen(false)}
							disabled={isPending}
						>
							Отмена
						</Button>
						<Button
							variant="red"
							onClick={handleReset}
							loading={isPending}
							disabled={isPending}
						>
							Да, сбросить прогресс
						</Button>
					</DialogFooter>
				}
			>
				<div className="space-y-4 p-6">
					<p className="text-gray-900">
						Вы уверены, что хотите сбросить весь прогресс по курсу{' '}
						{courseName && <strong>&ldquo;{courseName}&rdquo;</strong>}?
					</p>
					<p className="text-sm text-gray-600">
						Это действие необратимо. Будет удален прогресс по всем задачам и
						теоретическим материалам курса.
					</p>
				</div>
			</Dialog>
		</>
	);
};
